import type { ProviderDetail } from '@/api/providers';

/**
 * The owner-side trust facts the business page sends: who the reader knows
 * among its vouchers, whether the reader runs it, and the person behind it
 * when they chose to be shown. Each line is drawn only when the server sent it.
 */
export function ProviderTrustFacts({ provider }: { provider: ProviderDetail }) {
  const known = provider.vouchesFromPeopleYouKnow ?? null;
  const owner = provider.owner ?? null;
  return <div className="text-sm text-gray-700 space-y-1 mb-3">
    {known !== null && known > 0 && <p>{known === 1 ? '1 person you know vouched' : `${known} people you know vouched`}</p>}
    {provider.viewerRole && <p className="text-gray-500">You {provider.viewerRole === 'manager' ? 'help run' : 'own'} this business.</p>}
    {owner && <p>
      Run by {owner.name}
      {owner.roots && ` · roots in ${owner.roots.map((root) => root.place ?? root.name).join(', ')}`}
      {owner.languages && ` · speaks ${owner.languages.map((language) => language.name).join(', ')}`}
    </p>}
  </div>;
}
